import { EnergyPassportTableHeadDrawer } from "@/features/energy-passport/ui/detail-tables/components/energy-passport-table-head-drawer.tsx"
import type { ITableHeader } from "@/shared/components"

const headers: ITableHeader[][] = [
  [
    { label: "Квартал", rowSpan: 2, className: "min-w-[150px]" },
    { label: "Тип учета", rowSpan: 2 },
    { label: "Указанная мощность", rowSpan: 2 },
    { label: "Субпотребление", rowSpan: 2 },
    { label: "Итоговый объем потребления", rowSpan: 2, className: "min-w-[180px]" },
    { label: "из них", colSpan: 4, className: "!text-center" },
    { label: "Норма потребления", rowSpan: 2 },
    { label: "Макс. ном. мощность (/час)", rowSpan: 2, className: "min-w-[180px]" }
  ],
  [
    { label: "для тех. нужды", className: "whitespace-nowrap border-t" },
    { label: "для собственной нужды ", className: "whitespace-nowrap border-t" },
    { label: "для производства", className: "border-t whitespace-nowrap" },
    { label: "для жил-комм. нужды", className: "border-t whitespace-nowrap" }
  ]
]

export function EnergyPassportElectricPowerHead() {
  return <EnergyPassportTableHeadDrawer headers={headers} />
}
